module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"text":"Essa página está disponível somente para colaboradores MundiPagg.","backButton":"Volte para o Dash"},"en-US":{"text":"This page is only available to MundiPagg staff.","backButton":"Back to the Dash"}}')
  delete Component.options._Ctor
}
